import { HIDE_EMAIL } from '../../../../utils'

export const mobileRemoveMask = value =>
  value ? Number(value.replace(/\s/g, '').replace(/[^a-zA-Z0-9 ]/gim, '')) : 0

export const hideUserInformation = email => {
  return email.replace(HIDE_EMAIL, (_, a, b, c) => a + b.replace(/./g, '*') + c)
}

export const renderValidationText = (info, variant, validationText) =>
  info ? { variant, validation: { validationText } } : {}

export const renderToastSuccess = () => {
  window.PLURALL_ELO_TOAST_CONTAINER.addToast({
    variant: 'positive',
    text: 'Atualização realizada com sucesso.',
  })
}
